/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWashDryP = createReactComponent("wash-dry-p", "IconWashDryP", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5", key: "svg-1" }]
]);

export { IconWashDryP as default };
//# sourceMappingURL=IconWashDryP.js.map
